import angularModule from './devise_token_auth_client_module';

angularModule.factory('DeviseClient', [
    '$injector',
    $injector => {
        const $http = $injector.get('$http');
        const $rootScope = $injector.get('$rootScope');
        const ngDeviseTokenAuthClient = $injector.get('ngDeviseTokenAuthClient');
        const ConfigFactory = $injector.get('ConfigFactory');

        const DEVISE_API_ROOT = `${window.ENDPOINT_ROOT}/auth`;
        const OMNIAUTH_API_ROOT = `${window.ENDPOINT_ROOT}/omniauth`;

        return {
            showSelf: () =>
                ConfigFactory.getConfig().then(config => {
                    if (config.disableDevise()) return ngDeviseTokenAuthClient.validateUser();

                    return $http
                        .get(`${DEVISE_API_ROOT}/show_self.json`)
                        .then(response => {
                            const user = response.data;
                            $rootScope.$broadcast('auth:validation-success', user);
                            return user;
                        })
                        .catch(e => {
                            $rootScope.$broadcast('auth:validation-error', e);
                            throw e;
                        });
                }),
            signIn: params =>
                ConfigFactory.getConfig().then(config => {
                    if (config.disableDevise()) return ngDeviseTokenAuthClient.submitLogin(params);

                    return $http
                        .post(`${DEVISE_API_ROOT}/sign_in.json`, { user: params })
                        .then(response => {
                            const user = response.data;
                            $rootScope.$broadcast('auth:login-success', user);
                            return user;
                        })
                        .catch(e => {
                            $rootScope.$broadcast('auth:login-error', e);
                            throw e;
                        });
                }),
            signOut: () =>
                ConfigFactory.getConfig().then(config => {
                    if (config.disableDevise()) return ngDeviseTokenAuthClient.signOut();

                    return $http.delete(`${DEVISE_API_ROOT}/sign_out.json`);
                }),
            register: params =>
                ConfigFactory.getConfig().then(config => {
                    if (config.disableDevise()) {
                        // DTA returns `{ success: 'success', data: user }` and $http has a `response.data` method, hence the weird response.data.data
                        // https://github.com/lynndylanhurley/devise_token_auth/blob/master/app/controllers/devise_token_auth/registrations_controller.rb#L131
                        return ngDeviseTokenAuthClient.submitRegistration(params).then(response => response.data.data);
                    }

                    return $http
                        .post(`${DEVISE_API_ROOT}.json`, {
                            user: params,
                            'g-recaptcha-response': params['g-recaptcha-response'],
                        })
                        .then(response => response.data);
                }),
            requestResetPasswordToken: params =>
                ConfigFactory.getConfig().then(config => {
                    if (config.disableDevise()) return ngDeviseTokenAuthClient.requestPasswordReset(params);
                    return $http.post(`${DEVISE_API_ROOT}/password.json`, { user: params });
                }),
            updatePassword: params =>
                ConfigFactory.getConfig().then(config => {
                    if (config.disableDevise()) return ngDeviseTokenAuthClient.updatePassword(params);
                    return $http.put(`${DEVISE_API_ROOT}/password.json`, { user: params });
                }),
            omniauth: (provider, params, opts) =>
                ConfigFactory.getConfig().then(config => {
                    if (config.disableDevise()) return ngDeviseTokenAuthClient.authenticate(provider, opts);

                    window.location.href = `${OMNIAUTH_API_ROOT}/${provider}?${new URLSearchParams(params)}`;
                    return undefined;
                }),
        };
    },
]);
